import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { useQuery } from 'react-query';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import Http from '../../../../app/http';
import { ShopList as ShopListComponent } from './shop-list';
import Loading from '../../../../app/main/customers/customersList/loading';
import { usePaginationState } from '../../../infra/ui/table/use-pagination-state';
import { columns } from './columns';
export var ShopList = function (props) {
    var _a;
    var _b = usePaginationState(), pagination = _b.pagination, setPagination = _b.setPagination;
    // stores the max opened page index so we don't go back to the smaller page count when we go back
    // 20 by default because we know there are at least 20 pages
    var maxOpenedPageIndexRef = useRef(20);
    if (pagination.pageIndex > maxOpenedPageIndexRef.current) {
        maxOpenedPageIndexRef.current = pagination.pageIndex;
    }
    var shopsQuery = useQuery(['admin', 'shops', "page:".concat(pagination.pageIndex, "-size:").concat(pagination.pageSize)], function () {
        return Http.get('/shop', {
            limit: pagination.pageSize,
            skip: pagination.pageIndex * pagination.pageSize,
        });
    }, {
        keepPreviousData: true,
    });
    var table = useReactTable({
        columns: columns,
        data: shopsQuery.data || [],
        manualPagination: true,
        // this is a hack to work around the fact that we don't have a total count in the response
        // once the data batch is smaller that the page size, we know we're on the last page
        // until then just say there's at least one more page
        pageCount: ((_a = shopsQuery.data) === null || _a === void 0 ? void 0 : _a.length) < pagination.pageSize
            ? maxOpenedPageIndexRef.current + 1
            : maxOpenedPageIndexRef.current + 2,
        state: {
            pagination: pagination,
        },
        onPaginationChange: setPagination,
        getCoreRowModel: getCoreRowModel(),
        autoResetExpanded: true,
        enableExpanding: true,
    });
    if (shopsQuery.isLoading) {
        return _jsx(Loading, {});
    }
    return _jsx(ShopListComponent, { table: table, onShowAllClick: props.onShowAllClick });
};
